import { observer } from 'mobx-react-lite';
import fullScreenModalStore from './store';
import { SVGPureIcon } from '@/ui';
import copy from 'copy-to-clipboard';
import Other from '@/common/helper/other';
import { Tooltip, Skeleton } from 'antd';
import QrcodeShare from '../qrcode-share';
import HtmlViewTemplate from '@/components/html-viewer/view-template';
import Downloads from '../vnc-viewer/downloads';
import { Document, Page } from 'react-pdf';
import { HelperCore } from '@/common/dependencies';
import Markmap from '@/components/markmap';
import React from 'react';
import { saveSvgAsPng } from '@/utils/svg';
import { KNOWLEDGE_REFERER } from '@/components/input-file/shared';
import Markdown from '@/components/markdown';
import ScaleBox from '@/components/scale-box';
import { useMeasure } from 'react-use';
import "./index.scss"
import userStore from '@/store/user';

const FullScreenModal = observer(({ }) => {
  const svgRefCopyWrap = React.createRef();
  const svgRefCopy = React.createRef();
  const svgRef = React.createRef();
  const [markmap, setMarkmap] = React.useState(null);
  const [$refPdfContainer, { width: widthPdfContainer }] = useMeasure();

  if(!fullScreenModalStore.data.show) {
    return null;
  }

  return (
    <div className={[
      "fixed w-100vw h-100vh z-5000 bg-black bg-opacity-50 left-0 top-0 flex items-center justify-center",
      fullScreenModalStore.data.type != "mindmap" ? "fullscreen-fade-in" : ""
    ]}>
      <div className={`${fullScreenModalStore.data.size == "pop" ? "w-80vw h-80vh rounded-16px overflow-hidden" : "w-100vw h-100vh"} bg-[#F5F5F5] flex flex-col`}>
        <div className='w-full h-64px bg-white flex items-center justify-between'>
          <SVGPureIcon 
            name="full_screen_modal_back"
            className='size-24px ml-24px cursor-pointer'
            onClick={() => {
              fullScreenModalStore.setData({
                show: false
              });
            }}
          />
          <div className={['flex h-64px items-center gap-8px mr-24px', userStore.isBrand ? 'hidden' : '']}>
            <div 
              className='h-28px box-border rounded-6px border-1px border-black border-opacity-16 leading-26px px-10px cursor-pointer hover:bg-[rgba(0,0,0,0.03)] text-14px text-black'
              onClick={() => {
                if(fullScreenModalStore.data.size == "pop") {
                  fullScreenModalStore.setData({
                    size: ""
                  });
                  if(fullScreenModalStore.data.type == "mindmap") {
                    setTimeout(() => {
                      markmap?.fit?.()
                    }, 20)
                  }
                  return
                }
                fullScreenModalStore.setData({
                  show: false
                });
              }}
            >
              {
                fullScreenModalStore.data.size == "pop"
                ? "全屏"
                : "退出全屏"
              }
            </div>
            
            {
              fullScreenModalStore.data.data.shareUrl ? (
                <Tooltip 
                  title={
                    <QrcodeShare url={fullScreenModalStore.data.data.shareUrl} />
                  } 
                  color="white"
                  placement="bottomLeft"
                  arrow={false}
                  getPopupContainer={node => node}
                  destroyTooltipOnHide
                >
                  <div 
                    className='h-28px box-border rounded-6px border-1px border-black border-opacity-16 leading-26px px-10px cursor-pointer hover:bg-[rgba(0,0,0,0.03)] text-14px text-black'
                    onClick={() => {
                      const copied = copy(fullScreenModalStore.data.data.shareUrl);     
                      copied && Other.toast('复制成功', "success");
                    }}
                  >
                    分享
                  </div>
                </Tooltip>
              ) : null
            }

            {
              fullScreenModalStore.data.type == "ppt"
              ? (
                <Downloads
                  chatId={fullScreenModalStore.data.data.chatId}
                  msg_id={fullScreenModalStore.data.data.msg_id}
                />
              )
              : null
            }
            {
              fullScreenModalStore.data.data.url && (fullScreenModalStore.data.type == "pdf" || fullScreenModalStore.data.type == "markdown")
              ? (
                <Tooltip 
                  title="下载" 
                  destroyTooltipOnHide
                  getPopupContainer={node => node}
                >
                  <div
                    onClick={() => {
                      HelperCore.downloadPdfFile(fullScreenModalStore.data.data.url, fullScreenModalStore.data.data.fileName);
                    }}
                  >
                    <SVGPureIcon
                      name="full_screen_modal_download"
                      className="size-24px cursor-pointer hover:bg-[#f7f7f7] rounded-6px "
                    />
                  </div>
                </Tooltip>
              )
              : null
            }
            {
              fullScreenModalStore.data.type == "mindmap"
              ? (
                <Tooltip 
                  title="下载" 
                  destroyTooltipOnHide
                  getPopupContainer={node => node}
                >
                  <div
                    onClick={() => {
                      saveSvgAsPng(svgRefCopyWrap.current, fullScreenModalStore.data.data.title || "")
                    }}
                  >
                    <SVGPureIcon
                      name="full_screen_modal_download"
                      className="size-24px cursor-pointer hover:bg-[#f7f7f7] rounded-6px "
                    />
                  </div>
                </Tooltip>
              )
              : null
            }
          </div>
        </div>
        {
          fullScreenModalStore.data.type == "html" && fullScreenModalStore.data.data.shareId
          ? (
            <div className="w-full h-0 flex-grow flex justify-center box-border">
              <iframe
                src={`/api/html/detail?id=${fullScreenModalStore.data.data.shareId}`}
                className="size-full"
                sandbox="allow-scripts allow-same-origin allow-popups allow-downloads allow-modals allow-popups-to-escape-sandbox"
              />
            </div>
          )
          : null
        }
        {
          fullScreenModalStore.data.type == "html" && !fullScreenModalStore.data.data.shareId
          ? (
            <div className="w-full h-0 flex-grow flex justify-center box-border">
              <iframe
                src="about:srcdoc"
                className="size-full"
                srcDoc={HtmlViewTemplate.replace(
                  '{html_content_holder}',
                  fullScreenModalStore.data.data.content
                )}
                sandbox="allow-scripts allow-same-origin allow-popups allow-downloads allow-modals allow-popups-to-escape-sandbox"
              />
            </div>
          )
          : null
        }
        {
          fullScreenModalStore.data.type == "ppt" && fullScreenModalStore.data.data.shareId
          ? (
            <div className="w-full h-0 flex-grow flex justify-center pt-20px box-border overflow-auto nw-no-scroll">
              <div className='max-w-1000px w-full bg-white rounded-t-12px'>
                <div className='w-full flex flex-col gap-32px'>
                  {
                    fullScreenModalStore.data.data.contents ? fullScreenModalStore.data.data.contents.map((content, pageNO) => {
                      return (
                        <ScaleBox key={pageNO}>
                          <iframe
                            src={`/api/html/detail?id=${fullScreenModalStore.data.data.shareId}&page_index=${pageNO}`}
                            className="w-1280px h-720px"
                            sandbox="allow-scripts allow-same-origin allow-popups allow-downloads allow-modals allow-popups-to-escape-sandbox"
                          />
                        </ScaleBox>
                      )
                    })
                    : 
                    fullScreenModalStore.data.data.urls?.map((url, index) => {
                      return (
                        <ScaleBox key={index}>
                          <iframe
                            className="w-1280px h-720px"
                            key={index}
                            src={url}
                            sandbox="allow-scripts allow-same-origin allow-popups allow-downloads allow-modals allow-popups-to-escape-sandbox"
                          />
                        </ScaleBox>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          )
          : null
        }
        {
          fullScreenModalStore.data.type == "ppt" && !fullScreenModalStore.data.data.shareId
          ? (
            <div className="w-full h-0 flex-grow flex justify-center pt-20px box-border overflow-auto nw-no-scroll">
              <div className='max-w-1000px w-full bg-white rounded-t-12px'>
                <div className='w-full flex flex-col gap-32px'>
                  {
                    fullScreenModalStore.data.data.contents ? fullScreenModalStore.data.data.contents.map((content, index) => {
                      return (
                        <ScaleBox key={index}>
                          <iframe
                            className="w-1280px h-720px"
                            key={index}
                            srcDoc={HtmlViewTemplate.replace('{html_content_holder}', content)}
                            src="about:srcdoc"
                            sandbox="allow-scripts allow-same-origin allow-popups allow-downloads allow-modals allow-popups-to-escape-sandbox"
                          />
                        </ScaleBox>
                      )
                    })
                    : 
                    fullScreenModalStore.data.data.urls?.map((url, index) => {
                      return (
                        <ScaleBox key={index}>
                          <iframe
                            className="w-1280px h-720px"
                            key={index}
                            src={url}
                            sandbox="allow-scripts allow-same-origin allow-popups allow-downloads allow-modals allow-popups-to-escape-sandbox"
                          />
                        </ScaleBox>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          )
          : null
        }
        {
          fullScreenModalStore.data.type == "pdf"
          ? (
            <div className="h-0 flex-grow overflow-auto flex justify-center pt-20px box-border full-screen-scrollbar mr-4px">
              <div 
                className='max-w-1000px size-full bg-white rounded-t-12px' 
                ref={$refPdfContainer}
              >
                <Document 
                  file={fullScreenModalStore.data.data.url} 
                  className=""
                  externalLinkTarget="_blank"
                  error={() => {}}
                  onLoadSuccess={(data) => {
                    const { numPages } = data;
                    fullScreenModalStore.setData({
                      data: {
                        ...fullScreenModalStore.data.data,
                        numPages
                      }
                    })
                  }}
                  onLoadError={() => {}}
                >
                  {
                    new Array(fullScreenModalStore.data.data.numPages || 0).fill("").map((item, index) => {
                      return (
                        <Page
                          key={index}
                          pageNumber={index + 1}
                          loading={null}
                          className="flex justify-center items-center page"
                          width={widthPdfContainer}
                        />
                      )
                    })
                  }
                </Document>
              </div>
            </div>
          )
          : null
        }
        {
          fullScreenModalStore.data.type == "mindmap"
          ? (
            <div className={`w-full h-0 flex-grow pt-20px box-border flex justify-center ${HelperCore.isPhone() ? "" : "px-190px"}`}>
              <div className='max-w-1000px size-full bg-white rounded-t-12px p-30px box-border relative'>
                <Markmap
                  value={fullScreenModalStore.data.data.content} 
                  className="w-full h-full" 
                  ref={svgRef} 
                  markviewConf={{
                    autoFit: true, 
                    maxWidth: 250, 
                    fitRatio: 0.95, 
                    spacingVertical: 10, 
                    duration: 800
                  }}
                  onRender={(markmap) => { setMarkmap(markmap) }}
                />
                <div className='w-92px h-40px absolute bottom-36px -right-154px flex justify-between'>
                  <div 
                    className='size-40px flex items-center justify-center cursor-pointer bg-white rounded-8px box-border border-1px border-balck border-opacity-10 hover:bg-[rgba(0,0,0,0.03)]'
                    onClick={() => {
                      markmap?.rescale?.(1.25)
                    }}
                  >
                    <SVGPureIcon 
                      name="full_screen_modal_amplify"
                      className='size-24px'
                    />
                  </div>
                  <div 
                    className='size-40px flex items-center justify-center cursor-pointer bg-white rounded-8px box-border border-1px border-balck border-opacity-10 hover:bg-[rgba(0,0,0,0.03)]'
                    onClick={() => {
                      markmap?.rescale?.(0.8)
                    }}
                  >
                    <SVGPureIcon 
                      name="full_screen_modal_reduce"
                      className='size-24px'
                    />
                  </div>
                </div>
              </div>
              <div 
                ref={svgRefCopyWrap} 
                style={{
                  position: "fixed",
                  top: "0px",
                  left: "30000px",
                  padding: "32px",
                  paddingBottom: "0px",
                  width: "100vw",
                  height: "100vh",
                  boxSizing: "border-box",
                  zIndex: 100000
                }}
              >
                <Markmap 
                  value={fullScreenModalStore.data.data.content}
                  style={{
                    width: "100%",
                    height: "calc(100% - 114px)"
                  }} 
                  ref={svgRefCopy}
                  markviewConf={{ autoFit: true, zoom: true, pan: true, maxWidth: 400, spacingVertical: 20 }}
                />
                <div style={{
                  width: "100%",
                  height: "114px",
                  position: "relative"
                }}>
                  <img 
                    style={{width: "205px", height: "74px", position: "absolute", right: "0px", top: "8px"}}
                    src="https://p3.ssl.qhimg.com/t110b9a9301359874f5abf9b878.png"
                    alt="mindmap-logo" />
                </div>
              </div>
            </div>
          )
          : null
        }
        {
          fullScreenModalStore.data.type == "markdown"
          ? (
            <div className='bg-[#f5f5f5] flex justify-center pt-20px box-border overflow-auto full-screen-scrollbar mr-4px h-0 flex-grow'>
              <div 
                className='max-w-1000px w-full min-h-full bg-white rounded-12px p-30px box-border'
                style={{
                  height: "fit-content"
                }}
              >
                <Markdown
                  typing={false}
                  text={fullScreenModalStore.data.data.content}
                  className="!text-14px !leading-22px"
                  components={{
                    a: ({ href, children, ...props }) => {
                      const ext = HelperCore.getFileNameExt(href).toLowerCase();
                      const config = KNOWLEDGE_REFERER[ext];
    
                      if (
                        config &&
                        ((typeof children == 'string' && /\d/.test(children)) ||
                          (Array.isArray(children) &&
                            children.length == 1 &&
                            typeof children[0] == 'string' &&
                            /\d/.test(children[0])))
                      ) {
                        return (
                          <a
                            className={`!border-1px !border-solid rounded-full px-4px py-2px mx-8px relative -top-1px whitespace-nowrap inline-block text-12px font-bold-600 w-max select-none transform scale-90 origin-center`}
                            style={{
                              color: config.color,
                              borderColor: config.color,
                            }}
                            target="_blank"
                            href={href}
                          >
                            {children}
                            <span
                              className="opacity-30 mx-2px w-1px h-8px inline-block"
                              style={{
                                background: config.color,
                              }}
                            ></span>
                            {config.text}
                          </a>
                        );
                      }
    
                      return (
                        <a
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                          {...props}
                        >
                          {children}
                        </a>
                      );
                    },
                  }}
                />
              </div>
            </div>
          )
          : null
        }
      </div>
    </div>
  )
})

export default FullScreenModal;